import FullPageLoader from '@components/core/full-page-loader/full-page-loader';
import { PageLoadError } from '@components/page-load-error';
import { getCobrandQueryOptions } from '@features/navigation/api/get-cobrand';
import { getPerformanceDataQueryOptions } from '@features/performance/api/get-performance-data';
import {
  BetaFeaturesEnum,
  getBetaFeaturesQueryOptions,
} from '@src/api/beta-features/get-beta-features';
import { useThemeStore } from '@src/stores/theme-store';
import { GetCobrandResponse } from '@src/types/get-cobrand-response';
import { createFileRoute, redirect } from '@tanstack/react-router';
import React from 'react';
import { PerformanceLayout } from './-layouts/performance-layout';

export const Route = createFileRoute('/_authenticated/performance')({
  component: () => <PerformanceLayout />,
  beforeLoad: ({ context }) => {
    const data = context.queryClient.getQueryData(
      getBetaFeaturesQueryOptions.queryKey,
    );
    const airMaxEnabled = data?.find(
      ([key]) => key === BetaFeaturesEnum.AIR_MAX,
    )?.[1];

    if (!airMaxEnabled) {
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({
        href: `${import.meta.env.VITE_BASE_URL}/performance-report`,
      });
    }
  },
  loader: async ({ context }) => {
    await context.queryClient.ensureQueryData(getPerformanceDataQueryOptions);
    return null;
  },
  errorComponent: ({ error }) => (
    <PageLoadError pageName='Performance' error={error} />
  ),
  wrapInSuspense: true,
  pendingComponent: () => {
    const partner = useThemeStore.use.partner();
    const data: GetCobrandResponse | undefined =
      Route.useRouteContext().queryClient.getQueryData(
        getCobrandQueryOptions({ partner }).queryKey,
      );
    return <FullPageLoader cobrandImage={data?.image} />;
  },
});
